import { atlas } from '~/services/serviceInstances';

import { CreateGuidelineResponseData } from '../../types/playbooks/guidelines';

export const getGuidelines = async (
  search: string,
): Promise<{ data: CreateGuidelineResponseData[] }> => {
  const params: Record<string, string | number> = {};
  // TODO move the component layer once pagination is implemented
  params['page[limit]'] = 0;
  if (search) {
    params.search = search;
  }

  return atlas.get('guidelines', { params });
};
